import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../locales/translations';
import { SurveyComponent } from '../../../../models/SurveyTemplates';

interface TextareaFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
    field,
    value = '',
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.SURVEY_BUILDER]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event.target.value);
    };

    return (
        <TextField
            fullWidth
            multiline
            rows={field.properties?.rows || 4}
            value={value}
            onChange={handleChange}
            placeholder={field.placeholder || t('field_messages.textarea.enter_placeholder', { label: field.label }) as string}
            disabled={disabled}
            helperText={field.description}
        />
    );
};

export default TextareaField;
